import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer>
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <div className="copyright-box">
            <p className="copyright">&copy; Copyright <strong>Md Minhazur Rahman Rafi</strong>. All Rights Reserved <span>{new Date().getFullYear()}</span></p>
          </div>
        </div>
      </div>
    </div>
  </footer>
    );
};

export default Footer;